/* src/app/umbrella-common/components/password-strength-bar/password-strength-bar.component.scss */
.psm-bars {
  display: flex;
  gap: 5px;
  margin-top: 8px;
}
.psm-bar {
  flex: 1;
  height: 6px;
  border-radius: 3px;
  background: #e0e0e0;
  transition: background 0.3s;
}
.psm-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  margin-top: 4px;
  transition: color 0.3s;
}
/*# sourceMappingURL=password-strength-bar.component.css.map */
